import React from 'react';
import { FadeIn } from './FadeIn';
import { X } from 'lucide-react';
const failures = ["Standard sleep hygiene (dimming lights, tea) isn't strong enough to override a chemical cortisol spike.", 'Melatonin supplements often lead to "vivid dreams" and grogginess without stopping the actual heat-flash that wakes you up.', 'Over-the-counter sleep aids knock you out, but they don\'t solve the "hormonal thermostat" issue, leading to a fragmented, low-quality rest.', 'Relying on a "nightcap" actually spikes your body temperature 3 hours later, guaranteeing a midnight wake-up.'];
export function FailedSolutions() {
  return <section className="py-24 md:py-32 bg-[#111836] relative" data-id="element-35">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-36">
        <FadeIn data-id="element-37">
          <h2 className="text-3xl md:text-4xl font-serif text-center mb-16 text-white" data-id="element-38">
            Why What You Tried Didn't Work
          </h2>
        </FadeIn>

        <div className="space-y-4 md:space-y-6" data-id="element-39">
          {failures.map((text, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-40">
              <div className="flex items-start gap-5 bg-[#0B1029]/40 p-6 md:p-8 rounded-2xl border border-white/5" data-id="element-41">
                <div className="bg-red-500/10 p-2 rounded-full shrink-0 mt-0.5" data-id="element-42">
                  <X className="w-5 h-5 text-red-400" data-id="element-43" />
                </div>
                <p className="text-lg text-slate-300 font-light leading-relaxed" data-id="element-44">
                  {text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}